import type { KeyboardEvent, MouseEvent } from "react";
import { useTranslation } from "react-i18next";

export default function CopyableText({ text }: { text: unknown }) {
  const { t } = useTranslation();
  const my_text = text && text.toString ? text.toString() : String(text);

  const handleCopy = async (
    e?: MouseEvent<HTMLSpanElement> | KeyboardEvent<HTMLSpanElement>,
  ) => {
    e?.preventDefault();
    e?.stopPropagation();

    if (typeof navigator === "undefined" || !navigator.clipboard?.writeText) {
      return;
    }

    try {
      await navigator.clipboard.writeText(my_text);
    } catch {
      // no-op
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter" || e.key === " ") void handleCopy(e);
  };

  return (
    <>
      <span className="mr-1">{my_text}</span>
      <span
        onClick={handleCopy}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label={t("copyableText.copyLabel", { text: my_text })}
        title={t("copyableText.copy")}
        className="inline-flex items-center text-blue-600 cursor-pointer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="9" y="9" width="13" height="13" rx="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      </span>
    </>
  );
}
